import * as React from "react";
import { Modal, Form, Button, Label } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { useDispatch } from "@teamprevent/admin-redux";

import {
    APPROVE_PHYSIOTHERAPY_REFERRAL_REPORT,
    REQUEST_PHYSIOTHERAPY_CHANGES_REFERRAL_REPORT,
    REJECT_PHYSIOTHERAPY_REFERRAL_REPORT
} from "../../../physiotherapyReferralReport/actionTypes";
import {
    approvePhysiotherapyReferralReport,
    requestChangesPhysiotherapyReferralReport,
    rejectPhysiotherapyReferralReport
} from "../../../physiotherapyReferralReport/actions";

interface Props {
    task: TaskModel;
    open: boolean;
    onClose: () => void;
}

export const AdminApprovePhysiotherapyReferralReportModal: React.FunctionComponent<Props> = ({ onClose, open, task }) => {
    const dispatch = useDispatch();
    const [notes, setNotes] = React.useState<string>("");
    const [notesRequiredError, setNotesRequiredError] = React.useState(false);

    const onApprove = React.useCallback(() => {
        setNotesRequiredError(false);
        dispatch(approvePhysiotherapyReferralReport(task.caseId, task.id, notes));
        onClose();
    }, [dispatch, notes, onClose, task]);

    const onRequestChanges = React.useCallback(() => {
        if (!notes) {
            setNotesRequiredError(true);
            return;
        }
        setNotesRequiredError(false);
        dispatch(requestChangesPhysiotherapyReferralReport(task.caseId, task.id, notes));
        onClose();
    }, [dispatch, notes, onClose, task]);

    const onReject = React.useCallback(() => {
        setNotesRequiredError(false);
        dispatch(rejectPhysiotherapyReferralReport(task.caseId, task.id, notes));
        onClose();
    }, [dispatch, notes, onClose, task]);

    return (
        <Modal open={open}>
            <Modal.Header content="Review notes for referral consultation" />
            <Modal.Content>
                <Form>
                    <Input.Textarea readOnly label="Previous Notes" value={task.notes ?? ""} />
                    <Form.Field>
                        <Input.Textarea
                            label="Notes"
                            onChange={setNotes}
                            value={notes}
                        />
                    </Form.Field>
                    {notesRequiredError && <Label basic pointing color="red" content="Notes are required when requesting changes" />}
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <IsLoadingButton positive requestNames={APPROVE_PHYSIOTHERAPY_REFERRAL_REPORT} content="Approve" onClick={onApprove} />
                <IsLoadingButton requestNames={REQUEST_PHYSIOTHERAPY_CHANGES_REFERRAL_REPORT} content="Request Changes" onClick={onRequestChanges} />
                <IsLoadingButton negative requestNames={REJECT_PHYSIOTHERAPY_REFERRAL_REPORT} content="Reject" onClick={onReject} />
                <Button content="Cancel" onClick={onClose} />
            </Modal.Actions>
        </Modal>
    );
};
